import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
} from 'react-native';
import Plus from 'lucide-react-native/dist/esm/icons/plus.js';
import { useAuth } from '../contexts/AuthContext';
import { roleService } from '../services/auth/roleService';
import { Permission } from '../types/auth';

interface SubHeaderProps {
  title?: string;
  navigate?: (path: string) => void;
  showNewRequestButton?: boolean;
  rightElement?: React.ReactNode;
}

const isWeb = Platform.OS === 'web';

export const SubHeader: React.FC<SubHeaderProps> = ({
  title = 'View Requests',
  navigate,
  showNewRequestButton = false,
  rightElement
}) => {
  const { user } = useAuth();
  
  // Check if user has permission to create requests
  const canCreateRequest = roleService.hasPermission(user, Permission.CREATE_REQUEST);

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.title}>{title}</Text>
        <View style={styles.rightContainer}>
          {showNewRequestButton && canCreateRequest && (
            <TouchableOpacity
              style={styles.newRequestButton}
              onPress={() => navigate && navigate('/create-request?fresh=1')}
            >
              <Plus size={14} color="#fff" />
              <Text style={styles.newRequestText}>New Request</Text>
            </TouchableOpacity>
          )}
          {rightElement}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f8f9fa',
    width: '100%',
    alignItems: isWeb ? 'center' : 'stretch',
    paddingHorizontal: 20,
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    minHeight: 48,
    width: '100%',
    maxWidth: isWeb ? 1200 : undefined,
    alignSelf: isWeb ? 'center' : 'stretch',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: '#ff6b35',
    letterSpacing: 0.5,
  },
  rightContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  newRequestButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 6,
    backgroundColor: '#ff6b35',
    borderRadius: 6,
    justifyContent: 'center',
    minHeight: 32,
    gap: 6,
  },
  newRequestText: {
    fontSize: 14,
    color: '#fff',
    fontWeight: '500',
  },
});